import React from 'react';
import ServiceCollection from 'src/services/ServiceCollection';
import TPEAction from 'src/models/common/TPEAction';
import { SegmentTablesState } from 'src/services/segment-cdt/SegmentTablesState';

/**
 * Domain context for the Segment Data Tables feature, following the house pattern
 * (see `CalculationBuilderContext`). Holds `{ state, dispatch, services }`. Lives in its own module
 * so both the list view and the create-wizard children can consume it without an import cycle.
 */
export type SegmentTablesContextType = {
    state: SegmentTablesState;
    dispatch: React.Dispatch<TPEAction>;
    services: ServiceCollection;
};

export const SegmentTablesContext = React.createContext(null as unknown as SegmentTablesContextType);

export const SegmentTablesProvider = (props: {
    state: SegmentTablesState;
    dispatch: React.Dispatch<TPEAction>;
    services: ServiceCollection;
    children: React.ReactNode;
}) => {
    const { state, dispatch, services, children } = props;
    const value = React.useMemo(() => ({ state, dispatch, services }), [state, dispatch, services]);
    return <SegmentTablesContext.Provider value={value}>{children}</SegmentTablesContext.Provider>;
};
